import { render, staticRenderFns } from "./BaseInputSelect.vue?vue&type=template&id=4ddf423c&scoped=true&"
import script from "./BaseInputSelect.vue?vue&type=script&lang=js&"
export * from "./BaseInputSelect.vue?vue&type=script&lang=js&"
import style0 from "vue-select/dist/vue-select.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./BaseInputSelect.vue?vue&type=style&index=1&id=4ddf423c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddf423c",
  null
  
)

export default component.exports